import { useContext } from 'react';
import { BoxPropsContext } from './context';
import { IBoxInnerProps } from './types';

export function useBoxProps(): IBoxInnerProps {
  return useContext(BoxPropsContext);
}
